import Vue from 'vue'
import Vuetify from 'vuetify'
import App from './App.vue'
import VueRouter from 'vue-router'
import 'material-design-icons-iconfont/dist/material-design-icons.css' // Ensure you are using css-loader
import 'vuetify/dist/vuetify.min.css' // Ensure you are using css-loader

Vue.config.productionTip = false
Vue.use(Vuetify);
Vue.use(VueRouter);

import Leaderboard from "./components/Leaderboard.vue";
import Profile from "./components/Profile.vue";
import Callback from "./components/Callback.vue";

const routes = [
  { path: '/', component: Leaderboard },
  { path: '/leaderboard', component: Leaderboard },
  { path: '/callback', component: Callback },
  { path: '/profile/:userHash', component: Profile, props: (route) => { return { userHash: route.params.userHash } } },
  { path: '/profile/', component: Profile, props: () => { return { userHash: false } } }
]

const router = new VueRouter({
  mode: 'history',
  base: "/angelinvestor",
  routes // short for `routes: routes`
})

export { router };

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
